import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Observable } from 'rxjs';

import { IMediaFeatures } from 'rev-shared/media/IMediaFeatures';
import { MediaFeaturesService } from 'rev-shared/media/MediaFeatures.Service';
import { SecondMs } from 'rev-shared/date/Time.Constant';

import { VideoPlaybackComponent } from './VideoPlayback.Component';
import { VideoPlaybackService } from './VideoPlayback.Service';
import { VideoPlaybackSidebarButton } from './VideoPlaybackSidebarModel';

@Component({
	selector: 'video-playback-sidebar-panel',
	templateUrl: './VideoPlaybackSidebarPanel.Component.html'
})
export class VideoPlaybackSidebarPanelComponent implements OnInit {
	@Input() public selectedButtonId: string;
	@Output() public onCloseSidebar: EventEmitter<any> = new EventEmitter();
	@Output() public onChapterClick: EventEmitter<number> = new EventEmitter();

	public readonly SecondMs = SecondMs;
	public readonly VideoPlaybackSidebarButton = VideoPlaybackSidebarButton;

	public mediaFeatures: IMediaFeatures;
	public video$: Observable<any>;

	constructor(
		public VideoPlaybackComponent: VideoPlaybackComponent,
		private MediaFeatures: MediaFeaturesService,
		private VideoPlaybackSvc: VideoPlaybackService
	) { }

	public ngOnInit(): void {
		this.video$ = this.VideoPlaybackSvc.video$;
		this.MediaFeatures.getFeatures()
			.then(result => this.mediaFeatures = result);
	}

	public get isHeightFull(): boolean {
		return this.selectedButtonId === this.VideoPlaybackSidebarButton.PULSE;
	}

	public clickChapter({ time }: { time: number; }): void {
		this.VideoPlaybackComponent.updatePlayerSeekTime(time);
		this.onChapterClick.emit(time);
	}
}
